<template>
  <div class="empadronamiento__intro__main">
    <div class="empadronamiento__intro__main__form">
      <div class="empadronamiento__intro__main__form__container empadronamiento__success">
        <h2 class="empadronamiento__success__title" style="text-transform: uppercase;">Términos y condiciones</h2>
        <div style="text-align: justify;" v-html="termsTemplate"></div>
        <div>
          <input type="checkbox" v-model="acepted" style="margin-left:0px; margin-right: 10px;">
          <label for="scales" style="text-transform: uppercase;">Acepto los términos y condiciones</label>
        </div>
        <div>
          <input type="checkbox" v-model="manifestoAcepted" style="margin-left:0px; margin-right: 10px;">
          <label for="scales" style="text-transform: uppercase;">En mi carácter de propietario/inquilino manifiesto tener conocimiento y aceptar los reglamentos que tienen por objeto regular la actividad social, deportiva y de convivencia urbana de la Asociación Civil.</label>
        </div>
        <div class="empadronamiento__intro__button">
            <button-link back>
            <p>Volver</p>
            </button-link>
            <button v-if="!loadingForm" :class="acepted && manifestoAcepted ? 'active' : ''" @click="aceptarTerminos()" :disabled="!acepted || !manifestoAcepted">
            <p>Aceptar</p>
            </button>
            <button v-else disabled>Procesando ...</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState({
      ModelProcedure: state => state.manageVecino.ModelProcedure
    }),
  },
  data() {
    return {
      acepted: false,
      manifestoAcepted : false,
      loading: true,
      loadingForm: false,
      termsTemplate : ''
    };
  },
  mounted() {
      const self = this;
      self.$store.dispatch("getTerminosYCondiciones").then(terms => {
          self.termsTemplate = terms.TermsAndConditionsTemplate
      });
  },
  methods: {
    aceptarTerminos() {
      var self = this;
      self.ModelProcedure.TermsAccepted = true;
      self.loadingForm = true;
      self.$store
        .dispatch("updateProcedure", {
          model: self.ModelProcedure
        })
        .then(() => {
          self.loadingForm = false;
          self.$router.push('/vecino/success')
        });
    }
  }
};
</script>

<style>
</style>